import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const empleadosService = {
    getAllEmpleados,
    getEmpleadoById,
    setStateEmpleadoById,
    crudEmpleados,
    getRecursos,
    getMacrozonas,
    validateExistsDocument,
    getFilteredData,
    getZonaEspejosByVendedor
};

async function getAllEmpleados() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    let res = await fetch(`${url}/empleados/getAllEmpleados`, requestOptions)
    return res.json()
}

function getEmpleadoById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/empleados/getEmpleadoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudEmpleados(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/empleados/crudEmpleados`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateEmpleadoById(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/empleados/setStateEmpleadoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

async function getRecursos() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/empleados/getRecursos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

async function getMacrozonas() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/empleados/getMacrozonas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function validateExistsDocument(document) {
  // loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({document})
    };

    return fetch(`${url}/empleados/validateExistsDocument`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getFilteredData(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/empleados/getFilteredData`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getZonaEspejosByVendedor(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/empleados/getZonaEspejosByVendedor`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}




